export const getMatchedAction = (inlineAction, textualActionTriggerCode) => {
  let matchedAction = null;
  for (let i = 0; i < inlineAction.length; i += 1) {
      if (inlineAction[i].actionProperties.hasOwnProperty('generatedActionCode') && inlineAction[i].actionProperties.generatedActionCode === textualActionTriggerCode) {
          matchedAction = inlineAction[i];
          break;
      }
  }
  return matchedAction
}